<template>
  <div class="bookingBox h-full">
    <div class="book-widget-bg book-widget-booking-strip-size book-widget-size-all book-widget-horizontal">
      <form class="book-form-inline" target="" action="https://admin.boostmybookings.com/booking.php">
        <div id="book-checkin-holder" class="book-form-group"><label class="book-col-5 book-control-label"
            data-allow-hide="1" data-translate="1">Check in</label>
          <div class="book-col-7"><input class="book-form-control datepicker hasDatepicker" placeholder="Check-in"
              data-check-in="1" readonly="" data-translate="1" id="booking-strip-checkin-1"><i
              class="icon-book-calendar "></i></div>
        </div>
        <div id="book-guests-holder" class="book-form-group"><label class="book-col-5 book-control-label"
            data-allow-hide="1" data-translate="1">Guests</label>
          <div class="book-col-7"><select class="book-form-control book-adl" name="numadult" data-min-value="1"
              data-max-value="10" data-default-value="2" data-translate-min="guestSelect"
              data-translate-other="guestsSelect">
              <option value="1">1 Guest</option>
              <option value="2">2 Guests</option>
              <option value="3">3 Guests</option>
              <option value="4">4 Guests</option>
              <option value="5">5 Guests</option>
              <option value="6">6 Guests</option>
              <option value="7">7 Guests</option>
              <option value="8">8 Guests</option>
            </select></div>
        </div>
        <div class="book-form-group book-va-bottom">
          <div class="book-col-7"><button type="submit"
              class="book-btn book-btn-success book-btn-block book-size-md book-form-control" data-translate="1">Check
              availability</button></div>
        </div><input type="hidden" name="checkin" id="alt-checkin-0" value="2023-06-01"> <input type="hidden"
          name="checkout" id="alt-checkout-1"><input type="hidden" name="ownerid" value="23610"><input type="hidden"
          name="referer" :value="referrer"><input type="hidden" name="lang" value="en">
      </form>
    </div>
  </div>
</template>
  
<script>
export default {
  props: {
    referrer: "",
  },
  data() {
    return {
      accomodations: [],
      currentUrl: "",
    };
  },

  methods: {
    mipmap(src, res) {
      if (src.includes('https://media.xmlcal.com')) {
        var imgblocks = src.split("/");
        var imgfile = imgblocks[imgblocks.length - 1];
        var thumbnailimgsmall =
          imgfile.split(".")[0] + "." + res + "." + imgfile.split(".")[1];
        imgblocks[imgblocks.length - 1] = thumbnailimgsmall;
        return imgblocks.join("/");
      } else {
        return src;
      }
    },
    async getData() {
      try {
        let response = await fetch(
          this.$BMB_API +'api/' +
          this.$clientID +
          "/getProperties?showAll=True&limit=8",
          {
            headers: {
              "X-Requested-With": "XMLHttpRequest",
            },
          }
        );
        this.accomodations = await response.json();
      } catch (error) {
        console.log(error);
      }
    },
  },

  created() {
    this.getData();
    this.currentUrl = window.location.origin;
  },
};
</script>
  